import { render, staticRenderFns } from "./SectionImageBackground.vue?vue&type=template&id=4f583cd0&scoped=true&"
import script from "./SectionImageBackground.vue?vue&type=script&lang=ts&"
export * from "./SectionImageBackground.vue?vue&type=script&lang=ts&"
import style0 from "./SectionImageBackground.vue?vue&type=style&index=0&id=4f583cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f583cd0",
  null
  
)

export default component.exports